export const ADD_SINTOMA_ACUPUNTURA = "ADD_SINTOMA_ACUPUNTURA";
export const DELETE_SINTOMA_ACUPUNTURA = "DELETE_SINTOMA_ACUPUNTURA";
export const RESTART_SINTOMA_ACUPUNTURA = "RESTART_SINTOMA_ACUPUNTURA";
export const UPDATE_SINTOMA_ACUPUNTURA = "UPDATE_SINTOMA_ACUPUNTURA";
